import React, { useState, useEffect } from 'react';
import { Modal, Timeline, Icon, Button, Empty, Tooltip } from 'antd';
import {
  ModalBody,
  ModalContainer,
  Container,
  LoaderContainer,
} from '../../components/Modals/styles';
import { TimeLineDiv, AddressContainer, DetailsContainer } from './styles';
import { getEmailAuditDetails, downloadFile } from '../../utils/services/emailAuditAPI';
import Loader from '../../components/Loader';
import { withTranslation } from 'react-i18next';
import { EMAIL_AUDIT_DETAILS_MODAL as trans } from '../Dashboard/TranslationValues';

const NAMESPACES = ['EMAIL_AUDIT_DETAILS_MODAL']
const DetailsModal = props => {
  const { isVisible, onCancel, selectedID, t } = props;
  const [loading, setLoading] = useState(false);
  const [reqDetails, setReqDetails] = useState(null);
  useEffect(() => {
    (async () => {
      setLoading(true);
      if (selectedID) {
        let response = await getEmailAuditDetails(selectedID);
        if (response && response.data) {
          setReqDetails(response.data);
        } else {
          setReqDetails([]);
        }
      }
      setLoading(false);
    })();
    // eslint-disable-next-line
  }, [selectedID]);

  const downloadReq = async type => {
    let payload = {};
    if (type === 'payload') {
      payload.payload = true;
      payload.mailRequestId = selectedID;
    }
    if (type === 'eml') {
      payload.eml = true;
      payload.mailRequestId = selectedID;
    }
    let response = await downloadFile(payload);
  };
  const downloadErrorMsg = async id => {
    let payload = {
      message: true,
      emailAuditId: id,
    };
    let response = await downloadFile(payload);
  };
  return (
    <Container>
      <Modal
        title={''}
        visible={isVisible}
        maskClosable={false}
        centered
        width={1000}
        onCancel={onCancel}
        footer={false}
        className="audit_modal"
        style={{ padding: '0 !important' }}
      >
        <ModalBody>
          {loading ? (
            <LoaderContainer>
              <Loader />
            </LoaderContainer>
          ) : (
            <ModalContainer width="1000px" auditModal={true}>
              {/* Details {selectedID} */}
              {reqDetails && (
                <AddressContainer>
                  {reqDetails.mailRequestId && (
                    <>
                      <div className="mail">
                          <Icon type="mail" theme="filled" />
                        <h3>{t(trans.FAILED_EMAIL_REQUEST_ID_DETAIL_LABEL.key,trans.FAILED_EMAIL_REQUEST_ID_DETAIL_LABEL.value)}</h3>
                      </div>
                      <p className="add">{reqDetails.mailRequestId}</p>
                    </>
                  )}
                  {reqDetails.elapsedTime && (
                    <>
                      <div className="mail">
                        <Icon type="clock-circle" />
                        <h3>{t(trans.FAILED_EMAIL_ELAPSED_TIME_LABEL.key,trans.FAILED_EMAIL_ELAPSED_TIME_LABEL.value)}</h3>
                      </div>
                      <p className="add">
                        {reqDetails.elapsedTime > 60
                          ? Math.abs(reqDetails.elapsedTime / 60) + t(trans.FAILED_EMAIL_ELAPSED_TIME_MINUTE_LABEL.key,trans.FAILED_EMAIL_ELAPSED_TIME_MINUTE_LABEL.value)
                          : reqDetails.elapsedTime + t(trans.FAILED_EMAIL_ELAPSED_TIME_SECONDS_LABEL.key,trans.FAILED_EMAIL_ELAPSED_TIME_SECONDS_LABEL.value)}
                      </p>
                    </>
                  )}
                  {reqDetails.to && (
                    <>
                      <div className="mail">
                        <Icon type="mail" theme="filled" />
                        <h3>{t(trans.FAILED_EMAIL_TO_ADDRESS_LABEL.key,trans.FAILED_EMAIL_TO_ADDRESS_LABEL.value)}</h3>
                      </div>
                      <p>
                        {reqDetails.to.split(',').map(toAdd => {
                          return <p className="add">{toAdd}</p>;
                        })}
                      </p>
                    </>
                  )}
                  <>
                    <div className="mail">
                      <Icon type="mail" />
                      <h3>{t(trans.FAILED_EMAIL_CC_TO_LABEL.key,trans.FAILED_EMAIL_CC_TO_LABEL.value)}</h3>
                    </div>
                    <p>
                      {reqDetails.cc
                        ? reqDetails.cc.split(',').map(ccAdd => {
                            return <p className="add">{ccAdd}</p>;
                          })
                        : '-'}
                    </p>
                  </>
                  <>
                    <div className="mail">
                      <Icon type="mail" />
                      <h3>{t(trans.FAILED_EMAIL_BCC_TO_LABEL.key,trans.FAILED_EMAIL_BCC_TO_LABEL.value)}</h3>
                    </div>
                    <p>
                      {reqDetails.bcc
                        ? reqDetails.bcc.split(',').map(bccAdd => {
                            return <p className="add">{bccAdd}</p>;
                          })
                        : '-'}
                    </p>
                  </>
                </AddressContainer>
              )}
              <DetailsContainer>
                <div className="title">{t(trans.REQUEST_EMAIL_AUDIT_TIMELINE_DETAILS_TITLE.key,trans.REQUEST_EMAIL_AUDIT_TIMELINE_DETAILS_TITLE.value)}</div>
                <TimeLineDiv>
                  <Timeline
                    mode="alternate"
                    style={{
                      padding: '10px',
                      height: reqDetails?.details?.length < 6 && '100%',
                    }}
                  >
                    {reqDetails && reqDetails?.details?.length ? (
                      reqDetails?.details.map((mailReq, index) => {
                        return (
                          <Timeline.Item
                            dot={
                              <Icon
                                type={
                                  mailReq?.updatedOn !== ('' || null)
                                    ? mailReq?.statusCode?.toLowerCase()
                                        .includes('fail')
                                      ? 'close-circle'
                                      : 'check-circle'
                                    : 'loading'
                                }
                                theme={
                                  mailReq?.updatedOn !== ('' || null)
                                    ? mailReq?.statusCode?.toLowerCase()
                                        .includes('fail')
                                      ? 'filled'
                                      : 'filled'
                                    : ''
                                }
                              />
                            }
                          >
                            <p
                              className={
                                index === reqDetails.details.length - 1
                                  ? 'currentStep status'
                                  : 'status'
                              }
                            >
                              {mailReq.statusCode}
                            </p>{' '}
                            {mailReq.updatedOn}
                            {mailReq.statusMessage && (
                              <Tooltip title={t(trans.DOWNLOAD_EMAIL_FAILURE_ERROR_MESSAGE_TOOLTIP.key,trans.DOWNLOAD_EMAIL_FAILURE_ERROR_MESSAGE_TOOLTIP.value)}>
                                <Icon
                                  type="download"
                                  style={{ marginLeft: '10px', strokeWidth: '40' }}
                                  onClick={() => downloadErrorMsg(mailReq.id)}
                                />
                              </Tooltip>
                            )}
                          </Timeline.Item>
                        );
                      })
                    ) : (
                      <Empty />
                    )}
                  </Timeline>
                </TimeLineDiv>
                <div className="buttonDiv">
                  <Button type="primary" icon="download" onClick={() => downloadReq('payload')}>
                    {t(trans.DOWNLOAD_EMAIL_AUDIT_PAYLOAD_BUTTON.key,trans.DOWNLOAD_EMAIL_AUDIT_PAYLOAD_BUTTON.value)}
                  </Button>
                  {reqDetails &&
                    reqDetails?.details?.some(
                      req => req.statusCode === 'Shared Web Hook Response',
                    ) && (
                      <Button type="primary" icon="download" onClick={() => downloadReq('eml')}>
                        {t(trans.DOWNLOAD_EMAIL_AUDIT_FILE_BUTTON.key,trans.DOWNLOAD_EMAIL_AUDIT_FILE_BUTTON.value)}
                      </Button>
                    )}
                </div>
              </DetailsContainer>
            </ModalContainer>
          )}
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default withTranslation(NAMESPACES)(DetailsModal);
